import { util } from '@bingads-webui-campaign/report-shared';
import { fromLegacyTimeZone } from '@bingads-webui-universal/time-zone-converter';

export default ({ i18n, serverContext }) => ({
  key: 'created-on',
  name: i18n.getString(_TL_('Created on')),
  fieldName: 'CreatedAt',
  minWidth: 200,
  maxWidth: 250,
  isResizable: true,
  sortable: true,
  data: 'number',
  onRender: item => util.reformatDate(i18n, item.CreatedAt, fromLegacyTimeZone(serverContext.CurrentAccount.TimeZone), 'yMdhmsv'),
});
